//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import { BackendClientBase } from "./BackendClientBase";

export class SettingsBackendClient extends BackendClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    healthReady(version: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v{version}/Health/Ready";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthReady(_response);
        });
    }

    protected processHealthReady(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    healthLive(version: string): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v{version}/Health/Live";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealthLive(_response);
        });
    }

    protected processHealthLive(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetUserInfo(version: string): Promise<SwaggerResponse<UserInfo>> {
        let url_ = this.baseUrl + "/api/v{version}/userinfo";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetUserInfo(_response);
        });
    }

    protected processUserSettingsGetUserInfo(response: Response): Promise<SwaggerResponse<UserInfo>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserInfo.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserInfo>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSettingsUpdateUserInfo(version: string, body: UserInfo | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v{version}/userinfo";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsUpdateUserInfo(_response);
        });
    }

    protected processUserSettingsUpdateUserInfo(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetOrganisationInfo(version: string): Promise<SwaggerResponse<OrganisationInformation>> {
        let url_ = this.baseUrl + "/api/v{version}/orgainfo";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetOrganisationInfo(_response);
        });
    }

    protected processUserSettingsGetOrganisationInfo(response: Response): Promise<SwaggerResponse<OrganisationInformation>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrganisationInformation.fromJS(resultData200);
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<OrganisationInformation>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetSettings(category: string, version: string): Promise<SwaggerResponse<UserSettings[]>> {
        let url_ = this.baseUrl + "/api/v{version}/settings/{category}";
        if (category === undefined || category === null)
            throw new Error("The parameter 'category' must be defined.");
        url_ = url_.replace("{category}", encodeURIComponent("" + category));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetSettings(_response);
        });
    }

    protected processUserSettingsGetSettings(response: Response): Promise<SwaggerResponse<UserSettings[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSettings.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status === 406) {
            return response.text().then((_responseText) => {
            let result406: any = null;
            let resultData406 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result406 = ProblemDetails.fromJS(resultData406);
            return throwException("Not Acceptable", status, _responseText, _headers, result406);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<UserSettings[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    userSettingsSaveSettings(version: string, body: UserSettings[] | undefined): Promise<SwaggerResponse<void>> {
        let url_ = this.baseUrl + "/api/v{version}/settings";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsSaveSettings(_response);
        });
    }

    protected processUserSettingsSaveSettings(response: Response): Promise<SwaggerResponse<void>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return new SwaggerResponse(status, _headers, null as any);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                console.log('error save settings', _responseText);
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<void>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetPublisher(version: string): Promise<SwaggerResponse<Publisher[]>> {
        let url_ = this.baseUrl + "/api/v{version}/publishers";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetPublisher(_response);
        });
    }

    protected processUserSettingsGetPublisher(response: Response): Promise<SwaggerResponse<Publisher[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Publisher.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Publisher[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetJurisdictionTree(version: string): Promise<SwaggerResponse<Jurisdiction[]>> {
        let url_ = this.baseUrl + "/api/v{version}/jurisdictions";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetJurisdictionTree(_response);
        });
    }

    protected processUserSettingsGetJurisdictionTree(response: Response): Promise<SwaggerResponse<Jurisdiction[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Jurisdiction.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Jurisdiction[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetMagazines(siteId: string, version: string): Promise<SwaggerResponse<Magazine[]>> {
        let url_ = this.baseUrl + "/api/v{version}/magazines/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetMagazines(_response);
        });
    }

    protected processUserSettingsGetMagazines(response: Response): Promise<SwaggerResponse<Magazine[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Magazine.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<Magazine[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsRemoveMagazine(opusId: number, version: string, body: Magazine): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/v{version}/magazines/{opusId}";
        if (opusId === undefined || opusId === null)
            throw new Error("The parameter 'opusId' must be defined.");
        url_ = url_.replace("{opusId}", encodeURIComponent("" + opusId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsRemoveMagazine(_response);
        });
    }

    protected processUserSettingsRemoveMagazine(response: Response): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetModuleNotifications(siteId: string, version: string): Promise<SwaggerResponse<ModuleNotificationItem[]>> {
        let url_ = this.baseUrl + "/api/v{version}/modulenotifications/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetModuleNotifications(_response);
        });
    }

    protected processUserSettingsGetModuleNotifications(response: Response): Promise<SwaggerResponse<ModuleNotificationItem[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ModuleNotificationItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<ModuleNotificationItem[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsUpdateModuleNotifications(version: string, body: ModuleNotificationItem): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/v{version}/modulenotifications";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsUpdateModuleNotifications(_response);
        });
    }

    protected processUserSettingsUpdateModuleNotifications(response: Response): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsGetSearchJobs(version: string): Promise<SwaggerResponse<SearchJob[]>> {
        let url_ = this.baseUrl + "/api/v{version}/searchjobs";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetSearchJobs(_response);
        });
    }

    protected processUserSettingsGetSearchJobs(response: Response): Promise<SwaggerResponse<SearchJob[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SearchJob.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<SearchJob[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    /**
     * @return Success
     */
    userSettingsDeleteSearchJob(searchJobId: string, version: string): Promise<SwaggerResponse<boolean>> {
        let url_ = this.baseUrl + "/api/v{version}/searchjobs/{searchJobId}";
        if (searchJobId === undefined || searchJobId === null)
            throw new Error("The parameter 'searchJobId' must be defined.");
        url_ = url_.replace("{searchJobId}", encodeURIComponent("" + searchJobId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsDeleteSearchJob(_response);
        });
    }

    protected processUserSettingsDeleteSearchJob(response: Response): Promise<SwaggerResponse<boolean>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<boolean>>(new SwaggerResponse(status, _headers, null as any));
    }

    userSettingsGetAcademicTitles(version: string): Promise<SwaggerResponse<string[]>> {
        let url_ = this.baseUrl + "/api/v{version}/academictitles";
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUserSettingsGetAcademicTitles(_response);
        });
    }

    protected processUserSettingsGetAcademicTitles(response: Response): Promise<SwaggerResponse<string[]>> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return new SwaggerResponse(status, _headers, result200);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SwaggerResponse<string[]>>(new SwaggerResponse(status, _headers, null as any));
    }
}

export class Jurisdiction implements IJurisdiction {
    id?: string;
    name?: string | undefined;
    shortcut?: string | undefined;
    metaShortcut?: string | undefined;
    taxonomyShortcut?: string | undefined;
    sort?: number;
    readonly children?: Jurisdiction[] | undefined;

    constructor(data?: IJurisdiction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortcut = _data["shortcut"];
            this.metaShortcut = _data["metaShortcut"];
            this.taxonomyShortcut = _data["taxonomyShortcut"];
            this.sort = _data["sort"];
            if (Array.isArray(_data["children"])) {
                (<any>this).children = [] as any;
                for (let item of _data["children"])
                    (<any>this).children!.push(Jurisdiction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Jurisdiction {
        data = typeof data === 'object' ? data : {};
        let result = new Jurisdiction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortcut"] = this.shortcut;
        data["metaShortcut"] = this.metaShortcut;
        data["taxonomyShortcut"] = this.taxonomyShortcut;
        data["sort"] = this.sort;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IJurisdiction {
    id?: string;
    name?: string | undefined;
    shortcut?: string | undefined;
    metaShortcut?: string | undefined;
    taxonomyShortcut?: string | undefined;
    sort?: number;
    children?: Jurisdiction[] | undefined;
}

export class Magazine implements IMagazine {
    userId!: string;
    opusId!: number;
    stand!: string;
    siteId!: string;
    requestUrl!: string;
    werkname?: string | undefined;

    constructor(data?: IMagazine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.opusId = _data["opusId"];
            this.stand = _data["stand"];
            this.siteId = _data["siteId"];
            this.requestUrl = _data["requestUrl"];
            this.werkname = _data["werkname"];
        }
    }

    static fromJS(data: any): Magazine {
        data = typeof data === 'object' ? data : {};
        let result = new Magazine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["opusId"] = this.opusId;
        data["stand"] = this.stand;
        data["siteId"] = this.siteId;
        data["requestUrl"] = this.requestUrl;
        data["werkname"] = this.werkname;
        return data;
    }
}

export interface IMagazine {
    userId: string;
    opusId: number;
    stand: string;
    siteId: string;
    requestUrl: string;
    werkname?: string | undefined;
}

export class ModuleNotificationItem implements IModuleNotificationItem {
    userId!: string;
    moduleId!: number;
    moduleName?: string | undefined;
    buchSelected!: boolean;
    zeitschriftSelected!: boolean;
    hostUrl?: string | undefined;
    lastNotification?: Date | undefined;

    constructor(data?: IModuleNotificationItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.moduleId = _data["moduleId"];
            this.moduleName = _data["moduleName"];
            this.buchSelected = _data["buchSelected"];
            this.zeitschriftSelected = _data["zeitschriftSelected"];
            this.hostUrl = _data["hostUrl"];
            this.lastNotification = _data["lastNotification"] ? new Date(_data["lastNotification"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ModuleNotificationItem {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleNotificationItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["moduleId"] = this.moduleId;
        data["moduleName"] = this.moduleName;
        data["buchSelected"] = this.buchSelected;
        data["zeitschriftSelected"] = this.zeitschriftSelected;
        data["hostUrl"] = this.hostUrl;
        data["lastNotification"] = this.lastNotification ? this.lastNotification.toISOString() : <any>undefined;
        return data;
    }
}

export interface IModuleNotificationItem {
    userId: string;
    moduleId: number;
    moduleName?: string | undefined;
    buchSelected: boolean;
    zeitschriftSelected: boolean;
    hostUrl?: string | undefined;
    lastNotification?: Date | undefined;
}

export class NewsletterNotification implements INewsletterNotification {
    email?: string | undefined;
    newsletterActivated?: boolean;

    constructor(data?: INewsletterNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.newsletterActivated = _data["newsletterActivated"];
        }
    }

    static fromJS(data: any): NewsletterNotification {
        data = typeof data === 'object' ? data : {};
        let result = new NewsletterNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["newsletterActivated"] = this.newsletterActivated;
        return data;
    }
}

export interface INewsletterNotification {
    email?: string | undefined;
    newsletterActivated?: boolean;
}

export class OrganisationInformation implements IOrganisationInformation {
    organisation?: string[] | undefined;
    contacts?: SupportContact[] | undefined;
    emails?: SupportEmail[] | undefined;
    websites?: SupportWebsite[] | undefined;
    orga2FaEnabled?: boolean;
    user2FaEnabled?: boolean;

    constructor(data?: IOrganisationInformation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["organisation"])) {
                this.organisation = [] as any;
                for (let item of _data["organisation"])
                    this.organisation!.push(item);
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(SupportContact.fromJS(item));
            }
            if (Array.isArray(_data["emails"])) {
                this.emails = [] as any;
                for (let item of _data["emails"])
                    this.emails!.push(SupportEmail.fromJS(item));
            }
            if (Array.isArray(_data["websites"])) {
                this.websites = [] as any;
                for (let item of _data["websites"])
                    this.websites!.push(SupportWebsite.fromJS(item));
            }
            this.orga2FaEnabled = _data["orga2FaEnabled"];
            this.user2FaEnabled = _data["user2FaEnabled"];
        }
    }

    static fromJS(data: any): OrganisationInformation {
        data = typeof data === 'object' ? data : {};
        let result = new OrganisationInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.organisation)) {
            data["organisation"] = [];
            for (let item of this.organisation)
                data["organisation"].push(item);
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        if (Array.isArray(this.emails)) {
            data["emails"] = [];
            for (let item of this.emails)
                data["emails"].push(item.toJSON());
        }
        if (Array.isArray(this.websites)) {
            data["websites"] = [];
            for (let item of this.websites)
                data["websites"].push(item.toJSON());
        }
        data["orga2FaEnabled"] = this.orga2FaEnabled;
        data["user2FaEnabled"] = this.user2FaEnabled;
        return data;
    }
}

export interface IOrganisationInformation {
    organisation?: string[] | undefined;
    contacts?: SupportContact[] | undefined;
    emails?: SupportEmail[] | undefined;
    websites?: SupportWebsite[] | undefined;
    orga2FaEnabled?: boolean;
    user2FaEnabled?: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class Publisher implements IPublisher {
    id?: number;
    name?: string | undefined;
    key?: string | undefined;
    modOpusList?: { [key: string]: number[]; } | undefined;

    constructor(data?: IPublisher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.key = _data["key"];
            if (_data["modOpusList"]) {
                this.modOpusList = {} as any;
                for (let key in _data["modOpusList"]) {
                    if (_data["modOpusList"].hasOwnProperty(key))
                        (<any>this.modOpusList)![key] = _data["modOpusList"][key] !== undefined ? _data["modOpusList"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): Publisher {
        data = typeof data === 'object' ? data : {};
        let result = new Publisher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["key"] = this.key;
        if (this.modOpusList) {
            data["modOpusList"] = {};
            for (let key in this.modOpusList) {
                if (this.modOpusList.hasOwnProperty(key))
                    (<any>data["modOpusList"])[key] = (<any>this.modOpusList)[key];
            }
        }
        return data;
    }
}

export interface IPublisher {
    id?: number;
    name?: string | undefined;
    key?: string | undefined;
    modOpusList?: { [key: string]: number[]; } | undefined;
}

export class SearchJob implements ISearchJob {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    created?: Date;
    notiz?: string | undefined;
    lastProcessed?: Date | undefined;
    sfc?: string | undefined;
    status?: number;
    notify?: boolean;

    constructor(data?: ISearchJob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.notiz = _data["notiz"];
            this.lastProcessed = _data["lastProcessed"] ? new Date(_data["lastProcessed"].toString()) : <any>undefined;
            this.sfc = _data["sfc"];
            this.status = _data["status"];
            this.notify = _data["notify"];
        }
    }

    static fromJS(data: any): SearchJob {
        data = typeof data === 'object' ? data : {};
        let result = new SearchJob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["notiz"] = this.notiz;
        data["lastProcessed"] = this.lastProcessed ? this.lastProcessed.toISOString() : <any>undefined;
        data["sfc"] = this.sfc;
        data["status"] = this.status;
        data["notify"] = this.notify;
        return data;
    }
}

export interface ISearchJob {
    id?: string;
    title?: string | undefined;
    description?: string | undefined;
    created?: Date;
    notiz?: string | undefined;
    lastProcessed?: Date | undefined;
    sfc?: string | undefined;
    status?: number;
    notify?: boolean;
}

export class SupportContact implements ISupportContact {
    type?: SupportType;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    homepage?: string | undefined;

    constructor(data?: ISupportContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.salutation = _data["salutation"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.homepage = _data["homepage"];
        }
    }

    static fromJS(data: any): SupportContact {
        data = typeof data === 'object' ? data : {};
        let result = new SupportContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["salutation"] = this.salutation;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["homepage"] = this.homepage;
        return data;
    }
}

export interface ISupportContact {
    type?: SupportType;
    salutation?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    homepage?: string | undefined;
}

export class SupportEmail implements ISupportEmail {
    type?: SupportType;
    email?: string | undefined;

    constructor(data?: ISupportEmail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): SupportEmail {
        data = typeof data === 'object' ? data : {};
        let result = new SupportEmail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["email"] = this.email;
        return data;
    }
}

export interface ISupportEmail {
    type?: SupportType;
    email?: string | undefined;
}

export enum SupportType {
    Fachlich = "Fachlich",
    Technisch = "Technisch",
}

export class SupportWebsite implements ISupportWebsite {
    type?: SupportType;
    url?: string | undefined;

    constructor(data?: ISupportWebsite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SupportWebsite {
        data = typeof data === 'object' ? data : {};
        let result = new SupportWebsite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["url"] = this.url;
        return data;
    }
}

export interface ISupportWebsite {
    type?: SupportType;
    url?: string | undefined;
}

export class UserInfo implements IUserInfo {
    knownUser?: boolean;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    academicTitle?: string | undefined;
    salutation?: string | undefined;
    prefix?: string | undefined;
    aspSessionId?: string | undefined;
    ssoUser?: boolean;

    constructor(data?: IUserInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.knownUser = _data["knownUser"];
            this.userName = _data["userName"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.academicTitle = _data["academicTitle"];
            this.salutation = _data["salutation"];
            this.prefix = _data["prefix"];
            this.aspSessionId = _data["aspSessionId"];
            this.ssoUser = _data["ssoUser"];
        }
    }

    static fromJS(data: any): UserInfo {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["knownUser"] = this.knownUser;
        data["userName"] = this.userName;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["academicTitle"] = this.academicTitle;
        data["salutation"] = this.salutation;
        data["prefix"] = this.prefix;
        data["aspSessionId"] = this.aspSessionId;
        data["ssoUser"] = this.ssoUser;
        return data;
    }
}

export interface IUserInfo {
    knownUser?: boolean;
    userName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    academicTitle?: string | undefined;
    salutation?: string | undefined;
    prefix?: string | undefined;
    aspSessionId?: string | undefined;
    ssoUser?: boolean;
}

export class UserSettings implements IUserSettings {
    id!: number;
    value?: string | undefined;
    name?: string | undefined;

    constructor(data?: IUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.value = _data["value"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): UserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["value"] = this.value;
        data["name"] = this.name;
        return data;
    }
}

export interface IUserSettings {
    id: number;
    value?: string | undefined;
    name?: string | undefined;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}